class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.confettiTriggered = false;
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    // Listen for click outside drawer to close
    this.outsideClickListener = this.outsideClickListener.bind(this);
    document.addEventListener("click", this.outsideClickListener);

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  outsideClickListener(event) {
    const cartDrawer = this;
    const cartDrawerContent = this.querySelector("#CartDrawer");
    if (!cartDrawerContent.contains(event.target)) {
      this.close();
    }
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    // Get progress bar's width before it rerenders
    const progressBar = document.getElementById("progress");
    if (progressBar) {
      var currentProgress = progressBar.style.width;
    } else {
      var currentProgress = 0;
    }

    if (!parsedState.sections) {
      console.error("No sections found in parsed state");
      return;
    }

    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;

    const sectionsToRender = this.getSectionsToRender();
    // console.log("Sections to render:", sectionsToRender);
    sectionsToRender.forEach((section) => {
      const sectionHTML = parsedState.sections[section.id];
      // console.log(`Section ID: ${section.id}, HTML: ${sectionHTML}`);
      if (sectionHTML) {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        sectionElement.innerHTML = this.getSectionInnerHTML(
          sectionHTML,
          section.selector
        );
      } else {
        console.error(`No HTML found for section ID: ${section.id}`); // Add this line
      }
    });

    // Calculate the total quantity of items in the cart
    const cartDrawerHTML = parsedState.sections["cart-drawer"];
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = cartDrawerHTML;
    const itemElements = tempDiv.querySelectorAll(".cart-item");
    let totalQuantity = 0;
    itemElements.forEach((itemElement) => {
      const quantityElement = itemElement.querySelector(".quantity__input");
      if (quantityElement) {
        const quantityValue = quantityElement.value.trim();
        const quantity = parseInt(quantityValue, 10);
        // console.log("Parsed quantity:", quantity, "from value:", quantityValue);
        if (!isNaN(quantity)) {
          totalQuantity += quantity;
        } else {
          console.error("Invalid quantity:", quantityValue);
        }
      }
    });
    // console.log("Total quantity of items in cart:", totalQuantity);

    // Manually update the cart-icon-bubble content
    const cartIconBubble = document.getElementById("cart-icon-bubble");
    if (cartIconBubble) {
      const cartCountBubble =
        cartIconBubble.querySelector(".cart-count-bubble");
      if (totalQuantity > 0) {
        if (!cartCountBubble) {
          const newCartCountBubble = document.createElement("div");
          newCartCountBubble.className = "cart-count-bubble";
          newCartCountBubble.innerHTML = `<span>${totalQuantity}</span>`;
          cartIconBubble.appendChild(newCartCountBubble);
          // console.log("Added new cart count bubble:", newCartCountBubble);
        } else {
          cartCountBubble.innerHTML = `<span>${totalQuantity}</span>`;
          // console.log("Updated cart count bubble:", cartCountBubble);
        }
      } else if (cartCountBubble) {
        cartCountBubble.remove();
        // console.log("Removed cart count bubble");
      }
    } else {
      console.error("cart-icon-bubble element not found");
    }

    // Check progress bar width after rendering contents
    this.checkProgressBar(currentProgress);
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  // triggers on an add server response (e.g ATC)
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // Check free shipping bar to trigger confetti
  checkProgressBar(storedProgress) {
    const progressBar = document.getElementById("progress");
    if (storedProgress) {
      var currentProgress = progressBar.style.width;
      // If there is no current progressBar, get the data attribute as backup
      if (!currentProgress) {
        currentProgress = progressBar.getAttribute("data-current") + "%";
      }

      // console.log("Current progress:", currentProgress);
      // Hide bar if its above 100% and fire confetti
      if (parseFloat(currentProgress) >= 100) {
        // console.log("Progress is at 100%");

        progressBar.style.width = storedProgress;
        setTimeout(() => {
          progressBar.style.transition = "width 1s linear";
          progressBar.style.width = currentProgress;
        }, 200);

        const cartShippingElement = document.getElementById("cart-shipping");
        if (cartShippingElement && !this.confettiTriggered) {
          let confetti = new Confetti(cartShippingElement.id);
          confetti.setCount(75);
          confetti.setSize(1);
          confetti.setPower(25);
          confetti.setFade(false);
          confetti.destroyTarget(false);

          // Gets the center of the free shipping bar and triggers a click event (This prevents it from firing off to the side)
          const triggerConfetti = () => {
            const rect = cartShippingElement.getBoundingClientRect();
            const x = rect.left + rect.width / 2;
            const y = rect.top + rect.height / 2;

            if (x === 0 || y === 0) {
              setTimeout(triggerConfetti, 500);
            } else {
              setTimeout(() => {
                const event = new MouseEvent("click", {
                  clientX: x,
                  clientY: y,
                });
                cartShippingElement.dispatchEvent(event);
              }, 500);
              this.confettiTriggered = true;
            }
          };
          triggerConfetti();
        }
      } else {
        const filteredProgress = parseFloat(storedProgress.replace("%", ""));
        if (filteredProgress >= 100) {
          // If bar drops back below 100%
          if (filteredProgress == 100) {
            progressBar.style.width = filteredProgress + "%";
            setTimeout(() => {
              progressBar.style.transition = "width 1s linear";
              progressBar.style.width = currentProgress;
            }, 200);
          }
        } else {
          progressBar.style.width = storedProgress;
          setTimeout(() => {
            progressBar.style.transition = "width 1s linear";
            progressBar.style.width = currentProgress;
          }, 200);
        }
      }
    }
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  // Triggers on change server response (e.g quantity change)
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
